import './ServiceRequestsDiscover.scss';

import React, {
  useMemo,
  useRef,
} from 'react';

import { useNavigate } from 'react-router-dom';

import Header from '../../../../components/Header/Header';
import { useAppSelector } from '../../../../shared/hooks';
import { checkTQConnectAccess } from '../../../../shared/tqConnectUtils';
import { ROUTES } from '../../../../types/routes';
import TQConnectInfoCard
  from '../../components/TQConnectInfoCard/TQConnectInfoCard';
import TQServiceRequestList
  from '../../components/TQServiceRequestList/TQServiceRequestList';
import TQServiceRequestTitle
  from '../../components/TQServiceRequestTitle/TQServiceRequestTitle';
import TQTopContributersButton
  from '../../components/TQTopContributersButton/TQTopContributersButton';

const ServiceRequestsDiscover: React.FC = () => {
  const navigate = useNavigate();
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const handleBack = () => {
    navigate(-1);
  };

  const { tqConnectProfileCompletionResponses } = useAppSelector(
    (state) => state.user,
  );

  const { userAccessType } = checkTQConnectAccess();

  const isProfileNotCompleted = useMemo(() => {
    return (
      userAccessType === 'customer' &&
      (!tqConnectProfileCompletionResponses ||
        tqConnectProfileCompletionResponses.length === 0)
    );
  }, [tqConnectProfileCompletionResponses, userAccessType]);

  return (
    <div className="service-requests-discover__page page__container">
      <Header
        title={''}
        handleBack={handleBack}
        // customHeaderClass="chat-room-header-wrapper"
        actionItems={[
          isProfileNotCompleted ? null : (
            <TQTopContributersButton
              key="top-contributors"
              onClick={() => {
                navigate(ROUTES.TQ_CONNECT_TOP_CONTRIBUTORS);
              }}
            />
          ),
        ]}
      />
      <div
        ref={scrollContainerRef}
        className="page__content"
        id="service-requests-discover-scroll-container">
        {isProfileNotCompleted ? (
          <TQConnectInfoCard />
        ) : (
          <>
            <TQServiceRequestTitle />
            <TQServiceRequestList
              requestType="discover"
              scrollContainerRef={scrollContainerRef}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default ServiceRequestsDiscover;
